export default "__VITE_ASSET__458a2c38__"